// 引入常量
import {
  telreg,
  testExpress
} from './const.js'
import {
  ElMessage,
  ElMessageBox
} from "element-plus";



//*****公用方法******//

// 判断富文本编辑器输入是否为空或回车 提交文本过滤html、首尾空白
export function textFilter(str) {
  str = str.replace(/<[^<p>]+>/g, '') // 将所有<p>标签 replace ''
  str = str.replace(/<[</p>$]+>/g, '') // 将所有</p>标签 replace ''
  str = str.replace(/&nbsp;/gi, '') // 将所有 空格 replace ''
  str = str.replace(/<[^<br/>]+>/g, '') // 将所有 换行符 replace ''
  return str;
}
// 配合上面是否为空或回车使用
export function isEditorNull(str) {
  if (str == '') return true
  var regu = '^[ ]+$'
  var re = new RegExp(regu)
  return re.test(str)
}
// 对比数组去重
export function removeList(originList, delList) {
  var newArr = originList;
  delList.forEach((Element1, index1) => {
    originList.forEach((Element2, index2) => {
      if (isObjectValueEqual(Element1, Element2)) {
        newArr.splice(index2, 1);
      }
    });
  });
  originList = newArr;
  return originList;
  // 通过判断对象中键名组成的数组长度和名称是否相等来判断两个对象是否相等
  function isObjectValueEqual(id, name) {
    var aProps = Object.getOwnPropertyNames(id);
    var bProps = Object.getOwnPropertyNames(name);
    if (aProps.length != bProps.length) {
      return false;
    }
    for (var i = 0; i < aProps.length; i++) {
      var propName = aProps[i];
      var propA = id[propName];
      var propB = name[propName];
      if (typeof propA === "object") {
        if (this.isObjectValueEqual(propA, propB)) {
          return true;
        } else {
          return false;
        }
      } else if (propA !== propB) {
        return false;
      } else {}
    }
    return true;
  }
}

// 强制移除按钮焦点 解决element-plus按钮点击不失焦
export function lostFocus(event) {
  event.target.blur();
  if (event.target.nodeName == "SPAN") {
    event.target.parentNode.blur();;
  }
}
// 文件格式验证
//校验上传文件格式以及文件大小(针对单个文件文件)
//参数fileObj为上传文件对象, fromat格式，size大小， name类型
//返回true为校验通过 否则为失败
function uploadVerif(fileObj, format, size, name) {
  var _name = fileObj.name;
  var _size = fileObj.size;
  if (_name == "" || _name.lastIndexOf('.') <= 0) {
    ElMessage.warning('无效' + name + '，请重新选择上传！');
    return false;
  }
  //上传文件的扩展名 转换成小写 进行验证
  var splitDot = _name.split('.');
  var fileExtension = splitDot[splitDot.length - 1].toLowerCase();
  var extensions = format;
  if (extensions.indexOf(fileExtension) < 0) {
    // ElMessage.warning(name + "格式不正确！请重新上传格式为“" + extensions.join() + "”的" + name + "!", 5000);
    return false;
  }
  //上传文件大小 转换为kb 进行验证
  var _sizeKb = (parseFloat(_size) / 1024).toFixed(2); //上传的大小 单位kb
  if (_sizeKb > (size * 1024)) {
    ElMessage.warning('上传' + name + '过大(不能超过' + size + 'MB)，请重新选择上传！', 5000);
    return false;
  }
  return true;
}
// 图片
export function imgUploadVerif(fileObj) {
  return uploadVerif(fileObj, ["jpeg", "jpg", "bmp", "gif", "png", "bmp"], 5, '图片');
}
// 文件
export function fileUploadVerif(fileObj) {
  return uploadVerif(fileObj, ["doc", "docx", "xlsx", "pdf"], 10, '文件');
}

/** 格式化传入的url
 *  @newVal 传入的参数
 *  @isURIComponent 是否url解码
 *  @segmentation 以什么字符串分割
 * */
export function FormatUrlData(newVal, segmentation, isURIComponent) {
  segmentation = segmentation === undefined ? '"' : segmentation
  isURIComponent = isURIComponent == false ? isURIComponent : true
  if (isURIComponent) {
    newVal = decodeURIComponent(newVal);
  }
  return newVal.split(segmentation).filter((o) => /^((http):)/.test(o));
}
// 标准时间转'yyyy-MM-dd hh:mm'
export function formattingDate(date) {
  let time = new Date(date);
  var datetime = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate();
  return datetime
}
// 格式化数据截取url
// 日期格式转换
// ① "-"转"/"：time = time.replace(/-/g, "/"); //safari无法识别“-”符号，转化为“/”即可
// ② "/"转"-"：time = time.replace(/\//g, '-');
// ③ 自定义格式转换，引用例子: time = timeFormat(time, 'yyyy-MM-dd hh:mm'); //格式自定义
export function timeFormat(time, fmt) {
  const dateT = time ? time.replace(/-/g, "/") : '';
  var date = new Date(dateT);
  var o = {
    "M+": date.getMonth() + 1, //月份 
    "d+": date.getDate(), //日 
    "h+": date.getHours(), //小时 
    "m+": date.getMinutes(), //分 
    "s+": date.getSeconds(), //秒 
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度 
    "S": date.getMilliseconds() //毫秒 
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;
}
// 应对后台传递的时间为：2021-12-20T14:50:37.918774
export function timeFormatNew(time, fmt) {
  var date = new Date(time);
  var o = {
    "M+": date.getMonth() + 1, //月份 
    "d+": date.getDate(), //日 
    "h+": date.getHours(), //小时 
    "m+": date.getMinutes(), //分 
    "s+": date.getSeconds(), //秒 
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度 
    "S": date.getMilliseconds() //毫秒 
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;
}

// 倒计时：日、时、分、秒
export function countdownFormat(time) {
  // var duration = Math.floor((new Date(time) - new Date()) / 1000);
  const duration = time;
  if (duration <= 0) {
    return {
      date: '00',
      hours: '00',
      minites: '00',
      seconds: '00'
    };
  } else {
    let date = Math.floor(duration / (60 * 60 * 24));
    let hours = Math.floor(duration / (60 * 60)) - date * 24;
    let minites = Math.floor(duration / 60) - date * 24 * 60 - hours * 60;
    let seconds = duration - date * 24 * 60 * 60 - hours * 60 * 60 - minites * 60;
    if (date < 10) {
      date = '0' + date;
    }
    if (hours < 10) {
      hours = '0' + hours;
    }
    if (minites < 10) {
      minites = '0' + minites;
    }
    if (seconds < 10) {
      seconds = '0' + seconds;
    }
    return {
      date: date,
      hours: hours,
      minites: minites,
      seconds: seconds
    }
  }
}

// 将秒数转换为时分秒格式
export function formatSeconds(value) {
  var theTime = parseInt(value); // 秒
  var minutes = 0; // 分
  var hour = 0; // 小时
  if (theTime > 60) {
    minutes = parseInt(theTime / 60);
    theTime = parseInt(theTime % 60);
    if (minutes > 60) {
      hour = parseInt(minutes / 60);
      minutes = parseInt(minutes % 60);
    }
  }
  var result = "" + parseInt(theTime) + "秒";
  if (minutes > 0) {
    result = "" + parseInt(minutes) + "分" + result;
  }
  if (hour > 0) {
    result = "" + parseInt(hour) + "小时" + result;
  }
  return result;
}

// 数组重新排序
export function sortKey(array, key) { //（数组，排序属性）
  return array.sort(function (a, b) {
    var x = a[key];
    var y = b[key];
    return x > y ? -1 : x < y ? 1 : 0;
  })
}

// 非空判断
export function isNull(obj) {
  if (obj === undefined || obj === null || obj === "undefined" || obj === "null" || obj.length === 0 || obj === '00000000-0000-0000-0000-000000000000') {
    return true;
  }
  return false;
}

// html源码转纯文本
export function htmlToText(html) {
  if (!html) return;
  let result = html.replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '').replace(/<[^>]+?>/g, '').replace(/\s+/g, ' ').replace(/ /g, ' ').replace(/>/g, ' ');
  return result;
}
//按汉字截取指定字符串的长度
export function strSubString(str, len) {
  if (str.replace(/[\u4e00-\u9fa5]/g, '**').length <= len) {
    return str;
  }
  let _count = 0;
  let tmpStr = '';
  for (let i = 0; i < str.length; i++) { // 遍历字符串
    if (/[\u4e00-\u9fa5]/.test(str[i])) { // 中文 长度为两字节
      _count += 2;
    } else {
      _count += 1;
    }
    if (_count > len) {
      break;
    } else {
      tmpStr += str[i];
    }
  }
  return tmpStr;
}
//必须包含字母、数字，不限于特殊字符
const letterNumber = /^(?=.*\d)(?=.*[a-zA-Z])^[\da-zA-Z!#@?.$%^&*/]{8,16}$/;

export {
  letterNumber
}
// 表单校验自定义规则
// 确认密码
export function validatePass2(rule, value, callback, password) {
  if (value === password) {
    callback();
  } else {
    callback(new Error('两次输入密码不一致！'));
  }
};
// 姓名
export function validateName(rule, value, callback) {
  if (testExpress.test(value)) {
    return callback(new Error('姓名只能输入中文字符！'));
  } else {
    callback();
  }
};
// 电话号码
export function validateTel(rule, value, callback) {
  if (!telreg.test(value)) {
    return callback(new Error('请输入11位数手机号码！'));
  } else {
    callback();
  }
}


// 证件
export function validatecompanyCertificatesName(rule, value, callback) {
  if (value === 0) {
    return callback(new Error('请选择我方证件名称！'));
  } else {
    callback();
  }
}

export function dateformat(date, format) {
  const dateT = date ? date.replace(/-/g, "/") : '';
  if (!dateT) {
    return ''
  }
  let d = new Date(dateT)
  // 年
  if (/YYYY/.test(format)) {
    format = format.replace(/YYYY/, d.getFullYear())
  }
  // 月份
  let month = d.getMonth() + 1
  if (/MM/.test(format)) {
    let monthStr = month < 10 ? '0' + month : month
    format = format.replace(/MM/, monthStr)
  } else if (/M/.test(format)) {
    format = format.replace(/M/, month)
  }
  // 日期
  let dates = d.getDate()
  if (/DD/.test(format)) {
    let dateStr = dates < 10 ? '0' + dates : dates
    format = format.replace(/DD/, dateStr)
  } else if (/D/.test(format)) {
    format = format.replace(/D/, dates)
  }
  // 小时
  let hours = d.getHours()
  if (/HH/.test(format)) {
    let hoursStr = hours < 10 ? '0' + hours : hours
    format = format.replace(/HH/, hoursStr)
  } else if (/H/.test(format)) {
    format = format.replace(/H/, hours)
  } else if (/hh/.test(format)) {
    let hoursMin = hours > 12 ? hours - 12 : hours
    let hoursStr = hoursMin < 10 ? '0' + hoursMin : hoursMin
    format = format.replace(/hh/, hoursStr)
  } else if (/h/.test(format)) {
    let hoursMin = hours > 12 ? hours - 12 : hours
    format = format.replace(/h/, hoursMin)
  }
  // 分
  let minutes = d.getMinutes()
  if (/mm/.test(format)) {
    let minutesStr = minutes < 10 ? '0' + minutes : minutes
    format = format.replace(/mm/, minutesStr)
  } else if (/m/.test(format)) {
    format = format.replace(/m/, minutes)
  }
  // 秒
  let seconds = d.getSeconds()
  if (/ss/.test(format)) {
    let secondsStr = seconds < 10 ? '0' + seconds : seconds
    format = format.replace(/ss/, secondsStr)
  } else if (/s/.test(format)) {
    format = format.replace(/s/, seconds)
  }
  return format
}
// 根据管理员id获取管理员姓名
export function getAdminName(adminId) {
  let callback = "暂不知"
  let adminInfoList = JSON.parse(sessionStorage.getItem("AdminCache")).adminInfos
  adminInfoList.map(item => {
    if (item.adminId == adminId) {
      callback = item.adminName
    }
  })
  return callback
}
// 第一个时间大返回true
export function bjDate(date, date1) {
  var date = new Date(date);
  var date1 = new Date(date1);
  if (date.getTime() - date1.getTime() < 0) {
    return false;
  } else {
    return true;
  }
}

/**
 * @rulsFormSkip 校验表单跳转方法
 */
export function rulsFormSkip(obj, list) {
  let key = obj[Object.keys(obj)[0]][0].field
  let aaa = list.find(item => {
    let a = item.key.find((o) => o == key)
    if (!isNull(a)) {
           return item
    }
  })
  return Object.prototype.toString.call(aaa) == "[object Object]" && aaa.label || false
}

//  校验输入框内是否输入的全是空格
export function verifyTrim(obj) {
  if (obj) {
    return obj.split(" ").join("").length == 0
    // return obj.length > 0 && obj.trim().length != 0
  }
}
// 判断返回的HTML是否有内容
export function isHtmlContent(str) {
  str = decodeURIComponent(str)
  var data = JSON.parse(JSON.stringify(str))
  let deleteStr
  let labelLeft = data.indexOf('<')
  let labelright = data.indexOf('>')
  if (labelLeft != -1 && labelright != -1) {
    deleteStr = data.slice(labelLeft, labelright + 1)
    data = data.replace(deleteStr, '')
    if (data.indexOf('<') != -1) {
      return isHtmlContent(data)
    } else {
         labelLeft = ''
      labelright = ''
      return data
    }
  } {
    labelLeft = ''
    labelright = ''
    return data
  }
}

//判断是否isHttp
export function isHttp(value, rule) {
  var Expression = /(http|https):\/\/([\w.]+\/?)\S*/;
  var objExp = new RegExp(Expression);
  if (objExp.test(value)) {
    return true
  } else {
    return false
  }
}
//判断是否是数组元素
export function isArray(value) {
  if (Object.prototype.toString.call(value) == '[object Array]' && value.length > 0) {
    return true
  } else {
    return false
  }
}
//判断是否是对象元素
export function isObject(value) {
  if (Object.prototype.toString.call(value) == '[object Object]' && JSON.stringify(value) != '{}') {
    return true
  } else {
    return false
  }
}
//获取当前年往前多少年 
export function getYear(num) {
  var year = new Date().getFullYear(); //获取当前年
  let yearsSel = [];
  for (let i = 0; i < num; i++) {
    yearsSel.push({
      key: year - i,
      value: year - i + "年"
    });
  }
  return yearsSel
}
//判断年月日是否小于昨天
export function isDateLessThanYesterday(year, month, day) {
  const givenDate = new Date(year, month-1, day);
  var today = new Date();  // 获取当前日期
  var yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);  // 将日期减去1天
  return givenDate < yesterday;
}
export function compareDates(date1, date2) {
  return new Date(date1).getTime() > new Date(date2).getTime();
}

//编码
export function SUB_URL_Encode(value) {
  try {
        return encodeURIComponent(value);
  } catch (err) {
        return value;
  }
}
//解码
export function SUB_URL_Decode(value) {
  try {
        return decodeURIComponent(value);
  } catch (err) {
        return value;
  }
}
// 判断当前浏览器
export function isNumberBrowser() {

  // let arr =  navigator.userAgent.split(" ")
  // let lastStr = arr[arr.length - 1]
  // （谷歌和360浏览器）的判断
  // if (lastStr.indexOf('Safari') != -1) {
  if (navigator.userAgent.toLowerCase().includes('wow64')) {
    return '360'
  } else {
    let name = isNumberBrowser2()
    return name
  }
  // }
  // 其他浏览器返回空，后端会获取userAgent

}
// 谷歌和360浏览器
function isNumberBrowser2() {
  let is360 = false
  for (var key in navigator.plugins) {
    if (navigator.plugins[key].filename == 'np-mswmp.dll') {
      is360 = true
    }
  }

  if (is360) {
    return '360'
  } else {
    let flag = isNumberBrowser3("type", "application/vnd.chromium.remoting-viewer")
    if (flag) {
      return '360'
    } else {
      return ''
    }

  }

}
// 谷歌和360浏览器2
function isNumberBrowser3(option, value) {
  let mimeTypes = navigator.mimeTypes;
  for (var mt in mimeTypes) {
    if (mimeTypes[mt][option] == value) {
      return true;
    }
  }
  return false;
}
// 判断当前浏览器
export function nameBrowser() {
  let browseName = ''
  // （360浏览器）的判断
  if (navigator.userAgent.toLowerCase().includes('wow64')) {
    browseName = '360'
  } else {
    browseName = isNumberBrowser2()
  }
  if (browseName) {
    return browseName
  }
  // Chrome
  let arr = navigator.userAgent.split(" ")

  if (navigator.userAgent.indexOf("Chrome") !== -1 && navigator.userAgent.indexOf("Safari") !== -1 && arr[arr.length - 1].indexOf("Safari") !== -1) {
    return arr.filter(item => item.indexOf("Chrome") != -1)[0]
  }
  // 其他浏览器输出 最后一项
  return arr[arr.length - 1]

}